import Link from 'next/link';

import cn from '@/lib/clsxm';

import { Text } from '@/components/@base/typography';
import Props from '@/components/app/product/components/tags/tag/type';

import { DATA_CY_PRODUCT_TAG_NAME } from '@/constant/cypress';

export default function Tag({ title, slug, className }: Props) {
  return (
    <Link data-cy={DATA_CY_PRODUCT_TAG_NAME} prefetch={false} href={`/web/tag/${slug}`} className={cn(className, 'cursor-pointer truncate rounded-lg bg-[#FFFFFF] px-2 py-1.5 text-[#76767C] transition duration-300 hover:bg-[#878F9B] hover:text-[#FFFFFF]')}>
        {title}
    </Link>
  );
}
